if (typeof window !== 'undefined' && !window.__gCrWeb) {
  window['__gCrWeb'] = {};
}
